<template>
	<el-main class="info-wrap">
		<div class="info-box">
			<div>
				<div class="info-head tc">
					<h3>企业资料馆</h3>
				</div>
				<div class="info-content" v-html="infoText"></div>
			</div>
		</div>
	</el-main>
</template>

<script>
	export default {
		data() {
			return {
				infoText: `
<h3>让企业法规标准与内部资料真正“<strong>管得住、查得快、用得准、可追溯</strong>”</h3><p>“企业资料馆”是特规通企业版面向企业用户打造的专业资料管理与 AI 知识应用中心，集正版法规标准管理、企业内部资料归档、个人知识沉淀、书单分类授权、标准状态查新和 AI 检索问答于一体，帮助企业建立统一、清晰、合规、可持续使用的专业知识体系。</p><p>企业可将已购电子标准、常用法规标准清单、内部管理文件、技术资料、制度文件、项目资料等集中纳入资料馆管理，并按照企业类型、业务场景、设备类别、部门岗位、许可项目、项目任务等维度灵活创建书单，实现资料的分级分类管理。资料上传或加入书单后，可在 AI 问答模块中作为指定检索范围使用，让模型回答更聚焦企业实际业务场景，减少无关内容干扰，提升检索效率与答案准确性。</p><h3><strong>1）企业已购电子标准：正版资料集中管理，长期可查可用</strong></h3><p>企业已购电子法规标准将统一保存在“企业已购电子标准”列表中，支持在线查阅和下载使用。下载文件为带正版水印的 PDF，并进行加密保护，便于企业长期保存、规范使用和内部管理。</p><p>该模块帮助企业形成清晰的正版法规标准资产清单，让标准采购、资料使用、合规留痕形成闭环，适用于企业日常技术工作、体系管理、许可评审、监督检查和内部审核等场景。</p><h3><strong>2）法规标准收藏书单：按企业需要建立专属标准体系</strong></h3><p>企业可根据自身业务范围，从特规通法规标准库中建立专属收藏书单，也可一键引用平台针对不同企业类型提供的推荐书单，快速形成符合本单位实际需要的法规标准清单。</p><p>书单可按照许可项目、设备类别、业务流程、部门岗位、专项任务等方式灵活创建，例如“压力容器制造许可常用标准”“压力管道元件制造常用标准”“安全阀制造法规标准清单”“企业质量保证体系文件依据”等。</p><p>书单不仅用于分类管理，也可直接用于 AI 问答。用户在 AI 模块中选择对应书单后，系统将在该书单范围内进行检索和回答，使答案更贴近当前业务场景。书单还支持导出其中法规标准的正版来源说明，可用于企业许可评审、合规审核、资料准备和外部审查等场景。</p><h3><strong>3）标准状态查新：让每一份工作依据持续有效、变化可知</strong></h3><p>建立清单只是第一步，更难的是持续确认每一份文件是否仍然现行。标准一旦发布、修订、替代或废止，内部体系文件、作业文件和技术依据是否同步更新，往往只能依靠人工定期排查；文件数量一多就容易遗漏，甚至在评审、审核或实际业务中继续引用已经失效的标准。</p><p>“标准状态查新”将企业的法规标准清单与特规通持续更新的标准数据连接起来。用户只需完成一次清单建立，平台每天更新底层状态数据，跟踪列表随之自动刷新，把过去依赖临时查询、人工核对的静态清单，升级为自动更新、可筛选、可导出的动态管理台账。</p>  <ul><li><strong>最多跟踪 2000 份文件，覆盖企业核心法规标准体系</strong></li><p>每个用户可在标准状态查新中最多关注 2000 份法规标准，适合按企业许可范围、产品类别、专业方向、部门职责或质量体系要求，建立较完整的跟踪清单。</p>   <li><strong>每日更新状态数据，列表自动显示最新实施状态</strong></li><p>平台每天更新法规标准状态数据，用户的跟踪列表会随数据变化自动刷新。打开列表即可查看文件当前实施状态，快速识别现行、废止或仍需进一步确认的文件，减少逐份到外部平台重复查询。</p><li><strong>双向展示替代关系，不只知道“废止”，还知道“如何衔接”</strong></li><p>列表同时展示“替代了哪些标准”和“被哪些标准代替”。用户既能了解现行标准承接了哪些旧文件，也能在所关注文件被替代时快速找到后续标准线索，辅助判断内部制度、图纸、工艺文件和作业文件是否需要同步更新。</p><li><strong>支持手动创建与模板批量导入，快速建立跟踪清单</strong></li><p>文件较少时可直接手动新增；已有法规标准清单的用户，可下载导入模板后一次性整理并上传。系统自动解析标准编号和名称并进行匹配，显著降低大批量建表时的重复录入成本。</p><li><strong>统计、筛选与排序结合，重点变化一目了然</strong></li><p>列表上方集中展示文件类型和实施状态统计，点击统计项即可自动筛选对应文件；同时支持按添加时间、文件类型、发布时间等维度排序，帮助用户快速聚焦废止文件、特定类型或近期发布文件。</p><li><strong>全部数据一键导出，形成可复用的管理成果</strong></li><p>用户可一键导出跟踪列表中的全部数据，用于企业法规标准台账维护、质量体系评审、生产许可鉴定评审准备、内部审核、管理评审以及部门间更新通知等场景。</p></ul> <p>通过“建立—匹配—跟踪—核查—导出”五步，企业可将法规标准状态核查从一次性工作转变为持续性管理：无需等到评审、审核或项目启动前再集中排查，也不必仅依靠个人经验记住哪些标准已经换版，标准变化能够更早被发现并进入内部更新流程。</p> <h3><strong>4）企业知识库：企业内部资料统一归档，接入 AI 检索问答</strong></h3><p>企业知识库由企业主账号统一管理，支持上传文档、表格、图片等多种格式的企业内部资料。文件上传后可在线阅读，并经系统自动解析后接入 AI 检索问答，帮助企业把分散在各部门、各项目、各岗位中的资料沉淀为可查询、可复用的企业知识资产。</p><p>企业可通过书单对资料进行分类管理，并按组织分组授权给子账号查看和使用。不同部门、不同岗位、不同项目成员可以获得相应资料权限，既方便协同使用，也有助于控制资料访问范围。</p><p>文件需先在“全部文件”页面上传，上传完成后可添加至相关书单；同一文件可加入多个书单，满足企业多场景、多项目、多部门复用资料的管理需求。</p><h3><strong>5）个人知识库：每个账号的专属资料空间</strong></h3><p>个人知识库用于管理当前账号专属资料，支持子账号上传自己的文件资料，并在自动解析后接入 AI 检索问答。个人知识库文件仅当前账号可见，是用户自己的专属知识空间。</p><p>用户可根据学习、项目、岗位、日常工作等需要创建个人书单，并在 AI 模块中按书单进行检索使用。文件需先在“全部文件”页面上传，上传完成后可加入相关书单；同一文件可加入多个书单，方便个人按不同场景重复使用。</p><h3><strong>6）资料分级分类管理：让企业知识资产清晰有序</strong></h3><p>企业资料馆支持“企业级资料”和“个人级资料”分层管理，既满足企业统一管理、统一授权、统一沉淀的需要，也保留个人账号的专属资料空间。企业主账号可统一维护企业知识库和企业书单和标准状态查新跟踪清单，并通过分组授权控制子账号的查看和使用范围；子账号则可在授权范围内使用企业资料，同时维护自己的个人知识库。</p><p>通过“文件上传—书单分类—分组授权—状态查新—AI 使用”的管理方式，企业可以将法规标准、内部制度、技术资料、项目文件、培训资料、评审资料等进行体系化管理，避免资料分散、版本混乱、重复查找和权限不清等问题。</p><h3><strong>7）资料文件与 AI 打通：让知识真正进入业务场景</strong></h3><p>企业资料馆不是简单的文件存储工具，而是与特规通 AI 能力深度连接的企业知识入口。无论是正版法规标准、企业内部资料，还是个人上传文件，都可以通过书单组织后在 AI 问答中使用。</p><p>用户可根据当前任务选择对应书单，让 AI 在指定资料范围内检索、分析和回答。例如，企业可围绕许可评审、产品设计、质量体系、制造检验、人员培训、合同技术审查等场景建立专项书单，使 AI 回答更聚焦、更可控、更符合企业实际工作需要。</p><h3><strong>8）正版合规与许可评审应用：企业版核心价值</strong></h3><p>特规通企业版重点帮助企业解决法规标准资料“来源是否正版、清单是否完整、使用是否合规、审查是否可证明”的问题。通过企业已购电子标准、法规标准收藏书单和正版来源说明导出功能，企业可以更加规范地管理法规标准资料，形成可用于许可评审、体系审核、监督检查和内部合规管理的资料依据。</p><p>对于需要准备特种设备生产单位许可、鉴定评审、质量保证体系审核等工作的企业，资料馆可以帮助企业快速建立与许可范围相匹配的法规标准清单，集中管理正版电子标准和相关证明材料，并通过标准状态查新持续确认每一份依据的现行有效性与替代关系，结合 AI 辅助检索和问答提升资料准备、制度编写、条款核对和问题整改效率。</p><h3><strong>9）企业资料馆的核心价值</strong></h3><p>企业资料馆帮助企业把“买来的正版标准、平台收藏的法规清单、企业自己的内部资料、员工个人的工作文件”统一组织起来，形成可管理、可授权、可查新、可检索、可问答、可用于合规审核的企业知识体系。</p><p>它不仅是资料存储空间，更是特规通企业版连接法规标准、企业资料与 AI 应用的核心入口，让企业资料从“分散保存”走向“统一管理”，从“人工查找”走向“AI 辅助使用”，从“资料堆积”走向“合规可证、业务可用、知识可复用”。</p>
                `
			};
		}
	};
</script>

<style lang="less" scoped>
	.info-wrap {
		margin-left: 20px;
		padding: 20px 0 !important;
		font-size: 14px;
		color: #475569;
		line-height: 1.8;
		background-color: #fff;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
		border-radius: 12px;
		min-height: calc(100vh - 120px);
		h3 {
			margin: 0 0 10px;
			font-weight: 600;
			font-size: 24px;
			color: #334155;
		}
	}
	.info-item {
		margin-bottom: 20px;
	}
	.info-head {
		margin-bottom: 25px;
		padding-bottom: 15px;
		border-bottom: 1px dashed #e2e8f0;
		.topbox {
			color: #94a3b8;
			dd {
				margin: 0 30px 0 0;
			}
		}
	}
</style>

<style lang="less">
.info-content {
		padding: 0 30px;
		color: #0f172a;
	}

	.info-content h2 {
		margin: -4px 0 0 !important;
	}


	.info-content ul {
		li {
			line-height: 30px !important;
		}
	}

	.info-content p {
		margin-top: 6px !important;
		margin-bottom: 6px !important;
		line-height: 24px !important;
	}

	.info-content h3 {
		margin: 16px 0 6px !important;
	}

	.info-content h5 {
		color: #0f172a;
		font-size: 16px;
		margin: 0;
		padding: 0;
		line-height: 34px;
		margin-top: 10px;
	}

	.info-content h6 {
		color: #0f172a;
		font-size: 16px;
		margin: 0;
		padding: 0;
		line-height: 34px;
		position: relative;
	}

	.info-content h6:before {
		content: ' ';
		display: inline-block;
		width: 5px;
		height: 5px;
		background: #155dfc;
		border-radius: 50%;
		margin-right: 10px;
		position: absolute;
		top: 16px;
		left: 18px;
	}

	.info-box {
		padding-bottom: 30px;
	}

	.info-content li::marker {
		color: #1456f0;
	}
</style>